<template>
  <!-- GIS系统-物探点线数据-管线数据 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24" v-if="this.$store.state.user.info.systemAdmin">
            <a-form-item label="水司">
              <a-select placeholder="请选择" default-value v-model="query.tenantId" allow-clear>
                <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">{{
                  item.tenantName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="道路选择">
              <a-select mode="multiple" show-search v-model="query.road" placeholder="请选择道路（可多选）" allow-clear
                :max-tag-count="2">
                <a-select-option v-for="item in roadNameOptions" :key="item" :value="item">{{ item }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="分类编号">
              <a-input v-model="query.classNo" placeholder="请输入开始、结束分类编号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="物探点号">
              <a-input v-model="query.geophysicalPointNumber" placeholder="请输入物探点号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="管材">
              <a-select mode="multiple" placeholder="请选择管线材质（可多选）" v-model="query.pipeMaterial" allow-clear
                :max-tag-count="2">
                <a-select-option v-for="(item, index) in pipeLineMaterialOptions" :key="index" :value="item">{{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="管径">
              <a-select mode="multiple" placeholder="请选择管径大小（可多选）" v-model="query.pipeDiameter" allow-clear
                :max-tag-count="2">
                <a-select-option v-for="(item, index) in pipeDiameterSizeOptions" :key="index" :value="item">DN{{ item
                }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="创建时间" :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }">
              <a-range-picker v-model="createTimeRange" @change="onDateChange" format="YYYY-MM-DD HH:mm:ss"
                :show-time="{ defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')] }"
                style="width: 100%" />
            </a-form-item>
          </a-col>
          <!-- <a-col :md="6" :sm="12">
            <a-form-item label="竣工时间" :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }">
              <a-range-picker v-model="completionTimeRange" @change="onCompletionDateChange" format="YYYY-MM-DD HH:mm:ss"
                :show-time="{ defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')] }"
                style="width: 100%" />
            </a-form-item>
          </a-col> -->
        </a-row>
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryAll">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()" v-action:add>新增</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="downloadTemplate({ excelForm: true })"
                v-action:upload>下载模板</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="exportHandleIdList()" :loading="exportLoading"
                v-action:export>导出</a-button>
              <a-button type="primary" style="margin-left: 8px" :loading="importLoading" @click="importHandle"
                v-action:import>
                <a-icon type="upload" />导入
              </a-button>
              <a-button type="primary" icon="hdd" style="margin-left: 8px" @click="recycleBinVisible = true"
                v-action:recycle>回收站</a-button>
              <a-button type="primary" icon="check" style="margin-left: 8px" @click="dataCheckVisible = true"
                v-action:check>检查</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()"
                :loading="batchOperationLoading" v-action:del>删除</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="clear" v-action:clear>一键清空数据</a-button>

            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <a-table rowKey="id" bordered :row-selection="{
      selectedRowKeys: this.selectedRows,
      onChange: onSelectChange,
      getCheckboxProps: (record) => ({
        disabled: batchOperationLoading
      })
    }" :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
      :columns="columns" :loading="dataListLoading || batchOperationLoading" :pagination="pagination"
      :scroll="{ x: 2050 }" @change="pageChange">
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)" v-action:edit>编辑</a>
        <a-divider type="vertical" />
        <a @click="viewOnMap(record)" style="color: #1890ff">详情</a>
      </span>

    </a-table>
    <a-modal title="操作" style="top: 20px" :width="800" :maskClosable="false" v-model="addOrUpdateVisible" @ok="handleOk"
      @cancel="handleCancel">
      <a-form class="log-form" :form="addOrUpdateForm">
        <a-row class="form-row" :gutter="16">
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="起点编码">
              <a-input placeholder="起点编码" @blur="UpdateStartingPointEncoding"
                v-decorator="['startClassNo', { rules: [{ required: true, message: '起点编码' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="终点编码">
              <a-input placeholder="终点编码" @blur="UpdateStartingPointEncoding"
                v-decorator="['endClassNo', { rules: [{ required: true, message: '终点编码' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="物探点号">
              <a-input placeholder="物探点号" v-decorator="[
                'startGeophysicalPointNumber',
                { rules: [{ required: true, message: '请输入物探点号' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="连接点号">
              <a-input placeholder="连接点号"
                v-decorator="['endGeophysicalPointNumber', { rules: [{ required: true, message: '请输入连接点号' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="特征点">
              <a-input placeholder="特征点"
                v-decorator="['featurePoint', { rules: [{ required: false, message: '请输入特征点' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附属物">
              <a-input placeholder="附属物"
                v-decorator="['appendage', { rules: [{ required: false, message: '请输入附属物' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="构筑物">
              <a-input placeholder="构筑物"
                v-decorator="['structure', { rules: [{ required: false, message: '请输入附属物' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="地面高程">
              <a-input placeholder="地面高程" v-decorator="[
                'elevation',
                { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: false, message: '请输入地面高程m' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="起点埋深">
              <a-input placeholder="起点埋深" v-decorator="[
                'buriedDepth',
                { rules: [{ pattern: /^(\-|\+)?\d+(\.\d+)?$/, required: false, message: '请输入正确埋深' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="终点埋深">
              <a-input placeholder="终点埋深" v-decorator="[
                'endBuriedDepth',
                { rules: [{ pattern: /^(\-|\+)?\d+(\.\d+)?$/, required: false, message: '请输入正确终点埋深' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="埋设方式">
              <a-select
                v-decorator="['burialMethod', { initialValue: '直埋', rules: [{ required: false, message: '请选择埋设方式' }] }]"
                placeholder="请选择埋设方式" show-search option-filter-prop="children">
                <a-select-option value="直埋"> 直埋 </a-select-option>
                <a-select-option value="架空"> 架空 </a-select-option>
                <a-select-option value="顶管"> 顶管 </a-select-option>
                <a-select-option value="管廊"> 管廊 </a-select-option>
                <a-select-option value="管沟"> 管沟 </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="管材">
              <a-input placeholder="管材"
                v-decorator="['pipeMaterial', { rules: [{ required: true, message: '请输入管材' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="管径">
              <a-input placeholder="管径" v-decorator="[
                'pipeDiameter',
                { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: false, message: '请输入管径' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="管线属性">
              <a-select v-decorator="['pipeAttribute', { rules: [{ required: false, message: '请选择管线属性' }] }]"
                placeholder="请选择管线属性">
                <a-select-option value="原水管线"> 原水管线 </a-select-option>
                <a-select-option value="给水管线"> 给水管线 </a-select-option>
                <a-select-option value="消防管线"> 消防管线 </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
         
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="长度">
              <a-input placeholder="长度" v-decorator="[
                'length',
                { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: true, message: '请输入长度' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="压力等级">
              <a-select v-decorator="['voltageType', { rules: [{ required: true, message: '请选择压力等级!' }] }]"
                placeholder="选择压力等级" @change="handleSelectChange">
                <a-select-option value="市政压力"> 市政压力 </a-select-option>
                <a-select-option value="低压"> 低压 </a-select-option>
                <a-select-option value="中压"> 中压 </a-select-option>
                <a-select-option value="高压"> 高压 </a-select-option>
                <a-select-option value="超高压"> 超高压 </a-select-option>
              </a-select>
            </a-form-item> 
          </a-col> 
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="片区名称">
              <a-input placeholder="片区名称"
                v-decorator="['zoneName', { rules: [{ required: false, message: '请输入片区名称' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="道路选择">
              <a-input placeholder="道路选择"
                v-decorator="['road', { rules: [{ required: false, message: '请输入道路选择' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="原始文件名">
              <a-input placeholder="原始文件名"
                v-decorator="['originalFileName', { rules: [{ required: false, message: '请输入原始文件名' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="探测台组编号">
              <a-input placeholder="探测台组编号"
                v-decorator="['probeGroupNo', { rules: [{ required: false, message: '请输入探测台组编号' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工程名称">
              <a-input placeholder="工程名称"
                v-decorator="['projectName', { rules: [{ required: false, message: '请输入工程名称' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工程类别">
              <a-input placeholder="工程类别"
                v-decorator="['projectType', { rules: [{ required: false, message: '工程类别' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工程编号">
              <a-input placeholder="工程编号"
                v-decorator="['projectNo', { rules: [{ required: false, message: '工程编号' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="施工单位">
              <a-input placeholder="施工单位"
                v-decorator="['constructionUnit', { rules: [{ required: false, message: '施工单位' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工程管理人">
              <a-input placeholder="工程管理人"
                v-decorator="['projectManager', { rules: [{ required: false, message: '工程管理人' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工程负责人">
              <a-input placeholder="工程负责人"
                v-decorator="['projectLeader', { rules: [{ required: false, message: '工程负责人' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="竣工时间">
              <a-input placeholder="竣工时间"
                v-decorator="['completion_date', { rules: [{ required: false, message: '竣工时间' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
              <a-input placeholder="备注" v-decorator="['remark', { rules: [{ required: false, message: '备注' }] }]" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <RecycleBinModal :visible.sync="recycleBinVisible" @ok="modalFormOk"></RecycleBinModal>
    <DataCheck :visible.sync="dataCheckVisible" @ok="modalFormOk"></DataCheck>
    <importModal ref="importModal" :tree-data="zoneTreeData" @reLoad="resetList"
      exportUrl="/pipe-network/gis/pipe-lines/import"></importModal>
    <a-modal v-model="mapVisible" title="图层展示" width="60%" :mask="false" @ok="mapVisible = false">
      <div style="height: 500px">
        <collection-map ref="map" :type="1" :geo="geoJson" />
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import CollectionMap from '@/components/map/CollectionMap.vue'
import importModal from './module/ImportModalNotZone.vue'
import RecycleBinModal from './module/NewRecycleBinModal'
import DataCheck from './module/NewDataCheckModal'
import { listByGroupProperties } from '@/api/manage'
import { axios } from '@/utils/request'
import { handleImportBlobResponse } from '@/utils/importUtils'
const columns = [
  {
    title: '所在道路',
    dataIndex: 'road',
    ellipsis: true,
    width: 150,
    fixed: 'left'
  },
  {
    title: '起点编码',
    dataIndex: 'startClassNo',
    width: 150
  },
  {
    title: '终点编码',
    dataIndex: 'endClassNo',
    width: 150
  },
  {
    title: '物探点',
    dataIndex: 'startGeophysicalPointNumber',
    width: 150
    // ellipsis: true
  },
  {
    title: '连接点',
    dataIndex: 'endGeophysicalPointNumber',
    width: 150
    // ellipsis: true
  },
  {
    title: '特征点',
    dataIndex: 'featurePoint',
    width: 120
  },
  {
    title: '附属物',
    dataIndex: 'appendage',
    width: 120
  },
  {
    title: '构筑物',
    dataIndex: 'structure',
    width: 120
  },
  {
    title: '高程',
    dataIndex: 'elevation',
    width: 100
  },
  {
    title: '起点埋深',
    dataIndex: 'buriedDepth',
    width: 100
  },
  {
    title: '终点埋深',
    dataIndex: 'endBuriedDepth',
    width: 100
  },
  {
    title: '埋设方式',
    dataIndex: 'burialMethod',
    width: 120, 
  },
  {
    title: '管材',
    dataIndex: 'pipeMaterial',
    width: 120
  },
  {
    title: '管径',
    dataIndex: 'pipeDiameter',
    width: 100
  },
  {
    title: '管线属性',
    dataIndex: 'pipeAttribute',
    width: 120
  },

  {
    title: '长度(M)',
    dataIndex: 'length',
    width: 100
  },
  {
    title: '竣工时间',
    dataIndex: 'completionDate',
    width: 150,
    ellipsis: true
  },
  {
    title: '创建时间',
    width: 150,
    dataIndex: 'createTime',
    ellipsis: true,
    scopedSlots: { customRender: 'createTime' },
    fixed: 'right'
  },
  {
    title: '操作',
    width: 120,
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    fixed: 'right'
  }
]

export default {
  components: { CollectionMap, importModal, RecycleBinModal, DataCheck },
  mixins: [mixinViewModule],
  name: 'PipeLineLayer',
  data () {
    return {
      orderType: 'desc',
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `总长度: ${this.messages} m(米) \xa0\xa0\xa0\xa0\xa0\xa0 共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100', '200'],
        showQuickJumper: true
      },
      messages: '',
      mapVisible: false,
      currentId: '',
      // 批量操作相关
      batchOperationLoading: false,
      selectDebounceTimer: null,
      queryUrl: '/pipe-network/gis/pipe-lines/page',
      deleteUrl: '/pipe-network/gis/pipe-lines',
      addOrUpdateUrl: '/pipe-network/gis/pipe-lines',
      queryOneUrl: '/pipe-network/gis/pipe-lines',
      queryZoneDateUrl: 'zone-metering/zone-metering',
      exportDataUrl: 'pipe-network/gis/pipe-lines/export',
      exportFileName: '管线数据.xlsx',
      downloadTemplateUrl: 'pipe-network/gis/pipe-lines/template/download',
      downloadTemplateName: '管线数据导入模板.xlsx',
      importLoading: false,
      recycleBinVisible: false, // 回收站操作
      dataCheckVisible: false, // 数据检查
      createTimeRange: [], // 创建时间范围
      completionTimeRange: [], // 竣工时间范围
      geoJson: '',
      pipeLineMaterialOptions: [], // 管线材质选项
      pipeDiameterSizeOptions: [], // 管径大小选项
      zoneTreeData: [], // 片区选项
      roadNameOptions: [], // 道路选择选项
      query: {
        road: [],
        classNo: '',
        geophysicalPointNumber: '',
        connection: '',
        zoneId: '',
        tenantId: this.$store.state.user.info.tenantId,
        pipeMaterial: [],
        pipeDiameter: [],
        pipeAttribute: '',
        startCreateTime: '',
        endCreateTime: '',
        startCompletionDate: '',
        endCompletionDate: ''
      },
      labelCol: { span: 8 },
      wrapperCol: { span: 14 },
      columns,
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' })
    }
  },
  created () {
    this.getAllTenant()
    this.ListRoadNameOptions() // 道路选项下拉框模糊查询
    this.listPipeDiameterSizeOptions()
    this.listPipeLineMaterialOptions()
    this.getZoneData()
    
    // 先检查路由参数，决定是否需要自动搜索
    const { classNo, autoSearch } = this.$route.query
    if (!(classNo && autoSearch === 'true')) {
      // 正常初始化，不是从路由跳转过来的，执行重置和查询
      this.resetList()
      this.getLength()
    }
    // 如果是从路由跳转过来，不执行任何查询，等待mounted中处理
  },
  mounted () {
    // 检查是否从其他页面跳转过来，需要自动搜索
    const { classNo, autoSearch } = this.$route.query
    if (classNo && autoSearch === 'true') {
      console.log('从路由接收到分类编码:', classNo)
      // 设置查询条件
      this.query.classNo = classNo
      
      // 延迟执行查询，确保页面已完全加载
      this.$nextTick(() => {
        this.queryAll()
        // this.$message.success(`已自动搜索分类编码: ${classNo}`)
        
        // 查询完成后清除URL参数，避免刷新页面时重复自动搜索
        this.$router.replace({ 
          path: this.$route.path,
          query: {} 
        }).catch(() => {})
      })
    }
  },
  methods: {
    // 处理查询参数：空数组不传，有值则保持数组格式（后端期望数组格式）
    processQueryParams (query) {
      const params = { ...query }
      // 处理道路选择 - 保持数组格式
      if (Array.isArray(params.road)) {
        if (params.road.length === 0) {
          delete params.road
        }
        // 多个值保持数组格式，不转换为单个值
      }
      // 处理管材 - 保持数组格式
      if (Array.isArray(params.pipeMaterial)) {
        if (params.pipeMaterial.length === 0) {
          delete params.pipeMaterial
        }
        // 多个值保持数组格式，不转换为单个值
      }
      // 处理管径 - 保持数组格式
      if (Array.isArray(params.pipeDiameter)) {
        if (params.pipeDiameter.length === 0) {
          delete params.pipeDiameter
        }
        // 多个值保持数组格式，不转换为单个值
      }
      return params
    },
    // 序列化查询参数，确保数组正确序列化
    serializeParams (params) {
      const searchParams = new URLSearchParams()
      Object.keys(params).forEach(key => {
        const value = params[key]
        if (value !== undefined && value !== null && value !== '') {
          if (Array.isArray(value)) {
            // 数组格式：多个同名参数 param=value1&param=value2
            value.forEach(item => {
              searchParams.append(key, item)
            })
          } else {
            searchParams.append(key, value)
          }
        }
      })
      return searchParams.toString()
    },
    resetList () {
      if (this.query.sysType) {
        const params = {
          sysType: this.query.sysType
        }
        this.query = params
      } else {
        this.query = {
          tenantId: this.$store.state.user.info.tenantId,
          road: [],
          pipeMaterial: [],
          pipeDiameter: []
        }
      }
      this.createTimeRange = []
      this.completionTimeRange = []
      this.pagination.current = 1
      this.selectedRows = []
      
      // 清除URL中的查询参数，避免重复自动搜索
      if (this.$route.query.classNo || this.$route.query.autoSearch) {
        this.$router.replace({ 
          path: this.$route.path,
          query: {} 
        }).catch(() => {})
      }
      
      this.queryList()
      this.getLength()
    },
    onDateChange (date, dateString) {
      if (date && date.length === 2) {
        this.query.startCreateTime = dateString[0]
        this.query.endCreateTime = dateString[1]
      } else {
        this.query.startCreateTime = ''
        this.query.endCreateTime = ''
      }
    },
    onCompletionDateChange (date, dateString) {
      if (date && date.length === 2) {
        this.query.startCompletionDate = dateString[0]
        this.query.endCompletionDate = dateString[1]
      } else {
        this.query.startCompletionDate = ''
        this.query.endCompletionDate = ''
      }
    },
    // 覆盖 mixin 的 queryList 方法，处理多选参数
    queryList () {
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.processQueryParams(this.query)
      }
      if (this.needPage) {
        params.page = this.pagination.current
        params.limit = this.pagination.pageSize
      }
      this.dataListLoading = true
      this.$http
        .get(this.queryUrl, {
          params,
          paramsSerializer: (params) => {
            return this.serializeParams(params)
          }
        })
        .then(({ data }) => {
          this.dataListLoading = false
          if (this.needPage) {
            this.list = data.list || []
            this.selectedRows = []
            this.pagination.total = data.total ? parseInt(data.total) : 0
          } else {
            this.list = data
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    // 覆盖 mixin 的 pageQueryList 方法，处理多选参数
    pageQueryList () {
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.processQueryParams(this.query)
      }
      if (this.needPage) {
        params.page = this.pagination.current
        params.limit = this.pagination.pageSize
      }
      this.dataListLoading = true
      this.$http
        .get(this.queryUrl, {
          params,
          paramsSerializer: (params) => {
            return this.serializeParams(params)
          }
        })
        .then(({ data }) => {
          this.dataListLoading = false
          if (this.needPage) {
            this.list = data.list || []
            this.pagination.total = data.total ? parseInt(data.total) : 0
          } else {
            this.list = data
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    getLength () {
      const paramsQuery = this.processQueryParams(this.query)
      this.$http.get('/pipe-network/gis/pipe-lines/getLength', {
        params: paramsQuery,
        paramsSerializer: (params) => {
          return this.serializeParams(params)
        }
      }).then((res) => {
        this.messages = res.data
      })
    },
    queryAll () {
      this.queryList()
      this.getLength()
    },
    clear () {
      this.$confirm({
        title: '清空数据',
        content: `您确定要清空所有数据吗？`,
        centered: true,
        onOk: () => {
          this.$http.put('/pipe-network/gis/pipe-lines/empty/pipeline').then((res) => {
            if (res.code === 0) {
              this.$message.success('操作成功')
              this.queryList()
            }
          })
        }
      })
    },
    modalFormOk () {
      this.queryList()
    },
    importHandle () {
      this.$refs.importModal.show()
    },
    handleSelectChange (value) {
      this.addOrUpdateForm.setFieldsValue({
        voltageType: value
      })
    },
    saveFile (formData) {
      this.importLoading = true
      this.axios({
        method: 'post',
        url: '/pipe-network/gis/pipe-lines/import',
        headers: {},
        params: {},
        data: formData,
        responseType: 'blob'
      })
        .then((response) => handleImportBlobResponse(response, { errorFileName: '管线导入失败数据.xlsx' }))
        .then(({ hasErrorFile, message }) => {
          this.queryList()
          if (hasErrorFile) {
            this.$message.warning(message)
          } else {
            this.$message.success(message)
          }
        })
        .catch((error) => {
          this.$message.error(error.message || '导入失败')
        })
        .finally(() => {
          this.importLoading = false
        })
    },
    // 道路选项下拉框查询
    ListRoadNameOptions () {
      listByGroupProperties('road').then(({ data }) => {
        this.roadNameOptions = data
      })
    },
    getZoneData () {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    listPipeLineMaterialOptions () {
      listByGroupProperties('pipe_material').then(({ data }) => {
        this.pipeLineMaterialOptions = data
      })
    },
    listPipeDiameterSizeOptions () {
      listByGroupProperties('pipe_diameter').then(({ data }) => {
        this.pipeDiameterSizeOptions = data
      })
    },
    detailInfo (record) {
      this.detailForm = { ...record }
    },
    showLineLayer (record) {
      this.geoJson = record.geoJson
      this.mapVisible = true
    },
    // 起点分类编码和终点分类编码自动计算长度
    UpdateStartingPointEncoding () {
      const that = this
      const firstClassNo = this.addOrUpdateForm.getFieldValue('startClassNo')
      const secondClassNo = this.addOrUpdateForm.getFieldValue('endClassNo')
      // console.log(firstClassNo)
      // console.log(secondClassNo)
      if (firstClassNo !== '' && secondClassNo !== '' && firstClassNo !== undefined && secondClassNo !== undefined) {
        const distance = '/pipe-network/gis/pipe-lines/getDistance?firstClassNo=' + firstClassNo + '&secondClassNo=' + secondClassNo
        this.$http.get(distance)
          .then(res => {
            console.log(res.data)
            console.log('-----------', that.addOrUpdateForm)
            // 把计算的长度赋值给长度并取小数点后两位
            that.addOrUpdateForm.setFieldsValue({ length: parseFloat(res.data).toFixed(2) })
          })
      }
    },
    handleCancel () { },
    
    // 重写 handleOk 方法，在保存成功后刷新总长度
    handleOk () {
      const form = this.addOrUpdateForm
      form.validateFields((err, values) => {
        if (err) {
          return
        }
        if (!values.burialMethod) {
          values.burialMethod = '直埋'
        }
        
        this.dataListLoading = true
        
        // 编辑时需要带上 id
        if (this.isUpdate) {
          values.id = this.currentId
        }
        
        // 统一使用 POST 方法
        this.$http.post(this.addOrUpdateUrl, values)
          .then((res) => {
            if (res.code === 0) {
              this.$message.success(this.isUpdate ? '修改成功' : '新增成功')
              this.addOrUpdateVisible = false
              this.queryList()
              // ✅ 刷新总长度
              this.getLength()
              form.resetFields()
            }
          })
          .catch(() => {
            this.$message.error('操作失败')
          })
          .finally(() => {
            this.dataListLoading = false
          })
      })
    },
    // 优化的选择变化处理，添加防抖
    onSelectChange (selectedRowKeys) {
      // 清除之前的定时器
      if (this.selectDebounceTimer) {
        clearTimeout(this.selectDebounceTimer)
      }

      // 设置防抖延迟
      this.selectDebounceTimer = setTimeout(() => {
        this.selectedRows = selectedRowKeys
        console.log('选中行数:', selectedRowKeys.length)
      }, 100) // 100ms防抖延迟
    },
    // 优化的批量删除方法
    deleteSelectRow () {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return this.$message.warn('请选择要删除的数据')
      }

      // 限制批量删除数量
      if (this.selectedRows.length > 100) {
        return this.$message.warn('批量删除数量不能超过100条，请分批删除')
      }

      const _this = this
      console.log(_this.selectedRows)
      this.$confirm({
        title: `删除提醒`,
        content: `您确认要删除选择的${this.selectedRows.length}条数据吗?`,
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          _this.batchOperationLoading = true
          _this.$http
            .delete(_this.deleteUrl, {
              data: _this.selectedRows,
            })
            .then((res) => {
              if (res.code === 0) {
                _this.$message.success(`共删除${_this.selectedRows.length}条数据`)
                _this.selectedRows = []
                _this.resetList()
                _this.queryList()
              }
            })
            .catch(() => { })
            .finally(() => {
              _this.batchOperationLoading = false
            })
        },
        onCancel () {
          _this.selectedRows = []
          _this.$message.info('已取消删除')
        },
      })
    },
    // 在地图上查看管线详情
    viewOnMap (record) {
      // 解析 GeoJSON 数据
      let geoJsonData = null
      try {
        if (record.geoJson) {
          geoJsonData = typeof record.geoJson === 'string' ? JSON.parse(record.geoJson) : record.geoJson
          
          if (!geoJsonData || !geoJsonData.coordinates) {
            this.$message.warning('该数据没有有效的坐标信息')
            return
          }
        } else {
          this.$message.warning('该数据没有坐标信息')
          return
        }
      } catch (error) {
        console.error('解析 GeoJSON 失败:', error)
        this.$message.error('坐标数据格式错误')
        return
      }

      // 跳转到地图页面，携带完整的 GeoJSON 数据
      this.$router.push({
        path: '/new-one-map',
        query: {
          type: 'line', // 标识为管线
          startClassNo: record.startClassNo, // 起点编码
          endClassNo: record.endClassNo, // 终点编码
          geoJson: JSON.stringify(geoJsonData), // 完整的 GeoJSON 数据
          name: `${record.startGeophysicalPointNumber || ''}-${record.endGeophysicalPointNumber || ''}` // 管线名称
        }
      })
    }
  },
  watch: {},
  beforeDestroy () {
    // 清理防抖定时器
    if (this.selectDebounceTimer) {
      clearTimeout(this.selectDebounceTimer)
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}
</style>
